import * as React from 'react';

import './styles.css';

export default function LandingHeader() {
  return (
    <div className="landingHeader">
      <div className="backgroundImage flex justify-center items-center">
        <div className="headerContent">
          <div className="headerText">Buche jetzt deinen Therapeuten</div>
        </div>
      </div>
    </div>
  );
}
